import { render } from "./AssociacaoUsuarioVale.vue?vue&type=template&id=dea98f90&scoped=true"
import script from "./AssociacaoUsuarioVale.vue?vue&type=script&lang=js"
export * from "./AssociacaoUsuarioVale.vue?vue&type=script&lang=js"

import "./AssociacaoUsuarioVale.vue?vue&type=style&index=0&id=dea98f90&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dea98f90"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QBtn,QTable,QIcon,QTd,QPagination});
